[
  {
    "Id": "21",
    "Name": "Svalbard",
    "MunicipalityList": [
      { "Id": "2100", "Name": "Svalbard, Bjørnøya, Hopen", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "22",
    "Name": "Jan Mayen",
    "MunicipalityList": [
      { "Id": "2211", "Name": "Jan Mayen", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "34",
    "Name": "Innlandet",
    "MunicipalityList": [
      { "Id": "3452", "Name": "Vestre Slidre", "WarningList": [] },
      { "Id": "3435", "Name": "Vågå", "WarningList": [] },
      { "Id": "3451", "Name": "Nord-Aurdal", "WarningList": [] },
      { "Id": "3440", "Name": "Øyer", "WarningList": [] },
      { "Id": "3447", "Name": "Søndre Land", "WarningList": [] },
      { "Id": "3419", "Name": "Våler", "WarningList": [] },
      { "Id": "3422", "Name": "Åmot", "WarningList": [] },
      { "Id": "3407", "Name": "Gjøvik", "WarningList": [] },
      { "Id": "3442", "Name": "Østre Toten", "WarningList": [] },
      { "Id": "3429", "Name": "Folldal", "WarningList": [] },
      { "Id": "3428", "Name": "Alvdal", "WarningList": [] },
      { "Id": "3412", "Name": "Løten", "WarningList": [] },
      { "Id": "3443", "Name": "Vestre Toten", "WarningList": [] },
      { "Id": "3432", "Name": "Lesja", "WarningList": [] },
      { "Id": "3413", "Name": "Stange", "WarningList": [] },
      { "Id": "3418", "Name": "Åsnes", "WarningList": [] },
      { "Id": "3437", "Name": "Sel", "WarningList": [] },
      { "Id": "3411", "Name": "Ringsaker", "WarningList": [] },
      { "Id": "3439", "Name": "Ringebu", "WarningList": [] },
      { "Id": "3453", "Name": "Øystre Slidre", "WarningList": [] },
      { "Id": "3405", "Name": "Lillehammer", "WarningList": [] },
      { "Id": "3424", "Name": "Rendalen", "WarningList": [] },
      { "Id": "3416", "Name": "Eidskog", "WarningList": [] },
      { "Id": "3426", "Name": "Tolga", "WarningList": [] },
      { "Id": "3436", "Name": "Nord-Fron", "WarningList": [] },
      { "Id": "3434", "Name": "Lom", "WarningList": [] },
      { "Id": "3454", "Name": "Vang", "WarningList": [] },
      { "Id": "3414", "Name": "Nord-Odal", "WarningList": [] },
      { "Id": "3450", "Name": "Etnedal", "WarningList": [] },
      { "Id": "3431", "Name": "Dovre", "WarningList": [] },
      { "Id": "3425", "Name": "Engerdal", "WarningList": [] },
      { "Id": "3420", "Name": "Elverum", "WarningList": [] },
      { "Id": "3433", "Name": "Skjåk", "WarningList": [] },
      { "Id": "3446", "Name": "Gran", "WarningList": [] },
      { "Id": "3423", "Name": "Stor-Elvdal", "WarningList": [] },
      { "Id": "3441", "Name": "Gausdal", "WarningList": [] },
      { "Id": "3421", "Name": "Trysil", "WarningList": [] },
      { "Id": "3401", "Name": "Kongsvinger", "WarningList": [] },
      { "Id": "3417", "Name": "Grue", "WarningList": [] },
      { "Id": "3448", "Name": "Nordre Land", "WarningList": [] },
      { "Id": "3430", "Name": "Os", "WarningList": [] },
      { "Id": "3449", "Name": "Sør-Aurdal", "WarningList": [] },
      { "Id": "3438", "Name": "Sør-Fron", "WarningList": [] },
      { "Id": "3415", "Name": "Sør-Odal", "WarningList": [] },
      { "Id": "3403", "Name": "Hamar", "WarningList": [] },
      { "Id": "3427", "Name": "Tynset", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "46",
    "Name": "Vestland",
    "MunicipalityList": [
      { "Id": "4601", "Name": "Bergen", "WarningList": [] },
      { "Id": "4627", "Name": "Askøy", "WarningList": [] },
      { "Id": "4650", "Name": "Gloppen", "WarningList": [] },
      { "Id": "4645", "Name": "Askvoll", "WarningList": [] },
      { "Id": "4602", "Name": "Kinn", "WarningList": [] },
      { "Id": "4632", "Name": "Austrheim", "WarningList": [] },
      { "Id": "4638", "Name": "Høyanger", "WarningList": [] },
      { "Id": "4617", "Name": "Kvinnherad", "WarningList": [] },
      { "Id": "4615", "Name": "Fitjar", "WarningList": [] },
      { "Id": "4624", "Name": "Bjørnafjorden", "WarningList": [] },
      { "Id": "4616", "Name": "Tysnes", "WarningList": [] },
      { "Id": "4644", "Name": "Luster", "WarningList": [] },
      { "Id": "4647", "Name": "Sunnfjord", "WarningList": [] },
      { "Id": "4611", "Name": "Etne", "WarningList": [] },
      { "Id": "4620", "Name": "Ulvik", "WarningList": [] },
      { "Id": "4637", "Name": "Hyllestad", "WarningList": [] },
      { "Id": "4640", "Name": "Sogndal", "WarningList": [] },
      { "Id": "4646", "Name": "Fjaler", "WarningList": [] },
      { "Id": "4634", "Name": "Masfjorden", "WarningList": [] },
      { "Id": "4628", "Name": "Vaksdal", "WarningList": [] },
      { "Id": "4626", "Name": "Øygarden", "WarningList": [] },
      { "Id": "4623", "Name": "Samnanger", "WarningList": [] },
      { "Id": "4625", "Name": "Austevoll", "WarningList": [] },
      { "Id": "4631", "Name": "Alver", "WarningList": [] },
      { "Id": "4641", "Name": "Aurland", "WarningList": [] },
      { "Id": "4621", "Name": "Voss", "WarningList": [] },
      { "Id": "4614", "Name": "Stord", "WarningList": [] },
      { "Id": "4629", "Name": "Modalen", "WarningList": [] },
      { "Id": "4639", "Name": "Vik", "WarningList": [] },
      { "Id": "4635", "Name": "Gulen", "WarningList": [] },
      { "Id": "4613", "Name": "Bømlo", "WarningList": [] },
      { "Id": "4630", "Name": "Osterøy", "WarningList": [] },
      { "Id": "4619", "Name": "Eidfjord", "WarningList": [] },
      { "Id": "4649", "Name": "Stad", "WarningList": [] },
      { "Id": "4636", "Name": "Solund", "WarningList": [] },
      { "Id": "4612", "Name": "Sveio", "WarningList": [] },
      { "Id": "4642", "Name": "Lærdal", "WarningList": [] },
      { "Id": "4622", "Name": "Kvam", "WarningList": [] },
      { "Id": "4633", "Name": "Fedje", "WarningList": [] },
      { "Id": "4618", "Name": "Ullensvang", "WarningList": [] },
      { "Id": "4648", "Name": "Bremanger", "WarningList": [] },
      { "Id": "4643", "Name": "Årdal", "WarningList": [] },
      { "Id": "4651", "Name": "Stryn", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "42",
    "Name": "Agder",
    "MunicipalityList": [
      { "Id": "4213", "Name": "Tvedestrand", "WarningList": [] },
      { "Id": "4228", "Name": "Sirdal", "WarningList": [] },
      { "Id": "4219", "Name": "Evje og Hornnes", "WarningList": [] },
      { "Id": "4216", "Name": "Birkenes", "WarningList": [] },
      { "Id": "4227", "Name": "Kvinesdal", "WarningList": [] },
      { "Id": "4218", "Name": "Iveland", "WarningList": [] },
      { "Id": "4207", "Name": "Flekkefjord", "WarningList": [] },
      { "Id": "4201", "Name": "Risør", "WarningList": [] },
      { "Id": "4217", "Name": "Åmli", "WarningList": [] },
      { "Id": "4212", "Name": "Vegårshei", "WarningList": [] },
      { "Id": "4204", "Name": "Kristiansand", "WarningList": [] },
      { "Id": "4225", "Name": "Lyngdal", "WarningList": [] },
      { "Id": "4222", "Name": "Bykle", "WarningList": [] },
      { "Id": "4220", "Name": "Bygland", "WarningList": [] },
      { "Id": "4202", "Name": "Grimstad", "WarningList": [] },
      { "Id": "4205", "Name": "Lindesnes", "WarningList": [] },
      { "Id": "4206", "Name": "Farsund", "WarningList": [] },
      { "Id": "4224", "Name": "Åseral", "WarningList": [] },
      { "Id": "4223", "Name": "Vennesla", "WarningList": [] },
      { "Id": "4215", "Name": "Lillesand", "WarningList": [] },
      { "Id": "4211", "Name": "Gjerstad", "WarningList": [] },
      { "Id": "4221", "Name": "Valle", "WarningList": [] },
      { "Id": "4214", "Name": "Froland", "WarningList": [] },
      { "Id": "4203", "Name": "Arendal", "WarningList": [] },
      { "Id": "4226", "Name": "Hægebostad", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "33",
    "Name": "Buskerud",
    "MunicipalityList": [
      { "Id": "3324", "Name": "Gol", "WarningList": [] },
      { "Id": "3301", "Name": "Drammen", "WarningList": [] },
      { "Id": "3334", "Name": "Flesberg", "WarningList": [] },
      { "Id": "3303", "Name": "Kongsberg", "WarningList": [] },
      { "Id": "3328", "Name": "Ål", "WarningList": [] },
      { "Id": "3326", "Name": "Hemsedal", "WarningList": [] },
      { "Id": "3316", "Name": "Modum", "WarningList": [] },
      { "Id": "3332", "Name": "Sigdal", "WarningList": [] },
      { "Id": "3305", "Name": "Ringerike", "WarningList": [] },
      { "Id": "3330", "Name": "Hol", "WarningList": [] },
      { "Id": "3336", "Name": "Rollag", "WarningList": [] },
      { "Id": "3312", "Name": "Lier", "WarningList": [] },
      { "Id": "3314", "Name": "Øvre Eiker", "WarningList": [] },
      { "Id": "3338", "Name": "Nore og Uvdal", "WarningList": [] },
      { "Id": "3310", "Name": "Hole", "WarningList": [] },
      { "Id": "3322", "Name": "Nesbyen", "WarningList": [] },
      { "Id": "3320", "Name": "Flå", "WarningList": [] },
      { "Id": "3318", "Name": "Krødsherad", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "32",
    "Name": "Akershus",
    "MunicipalityList": [
      { "Id": "3222", "Name": "Lørenskog", "WarningList": [] },
      { "Id": "3212", "Name": "Nesodden", "WarningList": [] },
      { "Id": "3214", "Name": "Frogn", "WarningList": [] },
      { "Id": "3234", "Name": "Lunner", "WarningList": [] },
      { "Id": "3224", "Name": "Rælingen", "WarningList": [] },
      { "Id": "3205", "Name": "Lillestrøm", "WarningList": [] },
      { "Id": "3230", "Name": "Gjerdrum", "WarningList": [] },
      { "Id": "3238", "Name": "Nannestad", "WarningList": [] },
      { "Id": "3240", "Name": "Eidsvoll", "WarningList": [] },
      { "Id": "3236", "Name": "Jevnaker", "WarningList": [] },
      { "Id": "3207", "Name": "Nordre Follo", "WarningList": [] },
      { "Id": "3216", "Name": "Vestby", "WarningList": [] },
      { "Id": "3203", "Name": "Asker", "WarningList": [] },
      { "Id": "3228", "Name": "Nes", "WarningList": [] },
      { "Id": "3201", "Name": "Bærum", "WarningList": [] },
      { "Id": "3209", "Name": "Ullensaker", "WarningList": [] },
      { "Id": "3218", "Name": "Ås", "WarningList": [] },
      { "Id": "3220", "Name": "Enebakk", "WarningList": [] },
      { "Id": "3226", "Name": "Aurskog-Høland", "WarningList": [] },
      { "Id": "3232", "Name": "Nittedal", "WarningList": [] },
      { "Id": "3242", "Name": "Hurdal", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "11",
    "Name": "Rogaland",
    "MunicipalityList": [
      { "Id": "1120", "Name": "Klepp", "WarningList": [] },
      { "Id": "1121", "Name": "Time", "WarningList": [] },
      { "Id": "1133", "Name": "Hjelmeland", "WarningList": [] },
      { "Id": "1130", "Name": "Strand", "WarningList": [] },
      { "Id": "1112", "Name": "Lund", "WarningList": [] },
      { "Id": "1135", "Name": "Sauda", "WarningList": [] },
      { "Id": "1122", "Name": "Gjesdal", "WarningList": [] },
      { "Id": "1119", "Name": "Hå", "WarningList": [] },
      { "Id": "1160", "Name": "Vindafjord", "WarningList": [] },
      { "Id": "1127", "Name": "Randaberg", "WarningList": [] },
      { "Id": "1101", "Name": "Eigersund", "WarningList": [] },
      { "Id": "1111", "Name": "Sokndal", "WarningList": [] },
      { "Id": "1145", "Name": "Bokn", "WarningList": [] },
      { "Id": "1106", "Name": "Haugesund", "WarningList": [] },
      { "Id": "1151", "Name": "Utsira", "WarningList": [] },
      { "Id": "1144", "Name": "Kvitsøy", "WarningList": [] },
      { "Id": "1124", "Name": "Sola", "WarningList": [] },
      { "Id": "1134", "Name": "Suldal", "WarningList": [] },
      { "Id": "1114", "Name": "Bjerkreim", "WarningList": [] },
      { "Id": "1103", "Name": "Stavanger", "WarningList": [] },
      { "Id": "1146", "Name": "Tysvær", "WarningList": [] },
      { "Id": "1108", "Name": "Sandnes", "WarningList": [] },
      { "Id": "1149", "Name": "Karmøy", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "18",
    "Name": "Nordland",
    "MunicipalityList": [
      { "Id": "1812", "Name": "Sømna", "WarningList": [] },
      { "Id": "1839", "Name": "Beiarn", "WarningList": [] },
      { "Id": "1824", "Name": "Vefsn", "WarningList": [] },
      { "Id": "1832", "Name": "Hemnes", "WarningList": [] },
      { "Id": "1834", "Name": "Lurøy", "WarningList": [] },
      { "Id": "1818", "Name": "Herøy", "WarningList": [] },
      { "Id": "1857", "Name": "Værøy", "WarningList": [] },
      { "Id": "1845", "Name": "Sørfold", "WarningList": [] },
      { "Id": "1836", "Name": "Rødøy", "WarningList": [] },
      { "Id": "1841", "Name": "Fauske", "WarningList": [] },
      { "Id": "1804", "Name": "Bodø", "WarningList": [] },
      { "Id": "1835", "Name": "Træna", "WarningList": [] },
      { "Id": "1866", "Name": "Hadsel", "WarningList": [] },
      { "Id": "1867", "Name": "Bø", "WarningList": [] },
      { "Id": "1859", "Name": "Flakstad", "WarningList": [] },
      { "Id": "1822", "Name": "Leirfjord", "WarningList": [] },
      { "Id": "1848", "Name": "Steigen", "WarningList": [] },
      { "Id": "1815", "Name": "Vega", "WarningList": [] },
      { "Id": "1813", "Name": "Brønnøy", "WarningList": [] },
      { "Id": "1870", "Name": "Sortland", "WarningList": [] },
      { "Id": "1851", "Name": "Lødingen", "WarningList": [] },
      { "Id": "1806", "Name": "Narvik", "WarningList": [] },
      { "Id": "1865", "Name": "Vågan", "WarningList": [] },
      { "Id": "1871", "Name": "Andøy", "WarningList": [] },
      { "Id": "1868", "Name": "Øksnes", "WarningList": [] },
      { "Id": "1826", "Name": "Hattfjelldal", "WarningList": [] },
      { "Id": "1856", "Name": "Røst", "WarningList": [] },
      { "Id": "1874", "Name": "Moskenes", "WarningList": [] },
      { "Id": "1816", "Name": "Vevelstad", "WarningList": [] },
      { "Id": "1837", "Name": "Meløy", "WarningList": [] },
      { "Id": "1875", "Name": "Hamarøy", "WarningList": [] },
      { "Id": "1860", "Name": "Vestvågøy", "WarningList": [] },
      { "Id": "1840", "Name": "Saltdal", "WarningList": [] },
      { "Id": "1828", "Name": "Nesna", "WarningList": [] },
      { "Id": "1827", "Name": "Dønna", "WarningList": [] },
      { "Id": "1811", "Name": "Bindal", "WarningList": [] },
      { "Id": "1838", "Name": "Gildeskål", "WarningList": [] },
      { "Id": "1825", "Name": "Grane", "WarningList": [] },
      { "Id": "1820", "Name": "Alstahaug", "WarningList": [] },
      { "Id": "1833", "Name": "Rana", "WarningList": [] },
      { "Id": "1853", "Name": "Evenes", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "15",
    "Name": "Møre og Romsdal",
    "MunicipalityList": [
      { "Id": "1506", "Name": "Molde", "WarningList": [] },
      { "Id": "1514", "Name": "Sande", "WarningList": [] },
      { "Id": "1557", "Name": "Gjemnes", "WarningList": [] },
      { "Id": "1577", "Name": "Volda", "WarningList": [] },
      { "Id": "1573", "Name": "Smøla", "WarningList": [] },
      { "Id": "1508", "Name": "Ålesund", "WarningList": [] },
      { "Id": "1505", "Name": "Kristiansund", "WarningList": [] },
      { "Id": "1579", "Name": "Hustadvika", "WarningList": [] },
      { "Id": "1511", "Name": "Vanylven", "WarningList": [] },
      { "Id": "1531", "Name": "Sula", "WarningList": [] },
      { "Id": "1539", "Name": "Rauma", "WarningList": [] },
      { "Id": "1528", "Name": "Sykkylven", "WarningList": [] },
      { "Id": "1566", "Name": "Surnadal", "WarningList": [] },
      { "Id": "1580", "Name": "Haram", "WarningList": [] },
      { "Id": "1517", "Name": "Hareid", "WarningList": [] },
      { "Id": "1520", "Name": "Ørsta", "WarningList": [] },
      { "Id": "1554", "Name": "Averøy", "WarningList": [] },
      { "Id": "1563", "Name": "Sunndal", "WarningList": [] },
      { "Id": "1516", "Name": "Ulstein", "WarningList": [] },
      { "Id": "1515", "Name": "Herøy", "WarningList": [] },
      { "Id": "1576", "Name": "Aure", "WarningList": [] },
      { "Id": "1578", "Name": "Fjord", "WarningList": [] },
      { "Id": "1560", "Name": "Tingvoll", "WarningList": [] },
      { "Id": "1535", "Name": "Vestnes", "WarningList": [] },
      { "Id": "1525", "Name": "Stranda", "WarningList": [] },
      { "Id": "1532", "Name": "Giske", "WarningList": [] },
      { "Id": "1547", "Name": "Aukra", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "55",
    "Name": "Troms",
    "MunicipalityList": [
      { "Id": "5528", "Name": "Dyrøy", "WarningList": [] },
      { "Id": "5542", "Name": "Skjervøy", "WarningList": [] },
      { "Id": "5538", "Name": "Storfjord", "WarningList": [] },
      { "Id": "5524", "Name": "Målselv", "WarningList": [] },
      { "Id": "5526", "Name": "Sørreisa", "WarningList": [] },
      { "Id": "5522", "Name": "Salangen", "WarningList": [] },
      { "Id": "5546", "Name": "Kvænangen", "WarningList": [] },
      { "Id": "5503", "Name": "Harstad", "WarningList": [] },
      { "Id": "5516", "Name": "Gratangen", "WarningList": [] },
      { "Id": "5540", "Name": "Kåfjord", "WarningList": [] },
      { "Id": "5532", "Name": "Balsfjord", "WarningList": [] },
      { "Id": "5544", "Name": "Nordreisa", "WarningList": [] },
      { "Id": "5510", "Name": "Kvæfjord", "WarningList": [] },
      { "Id": "5501", "Name": "Tromsø", "WarningList": [] },
      { "Id": "5512", "Name": "Tjeldsund", "WarningList": [] },
      { "Id": "5514", "Name": "Ibestad", "WarningList": [] },
      { "Id": "5534", "Name": "Karlsøy", "WarningList": [] },
      { "Id": "5530", "Name": "Senja", "WarningList": [] },
      { "Id": "5536", "Name": "Lyngen", "WarningList": [] },
      { "Id": "5518", "Name": "Lavangen", "WarningList": [] },
      { "Id": "5520", "Name": "Bardu", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "50",
    "Name": "Trøndelag",
    "MunicipalityList": [
      { "Id": "5031", "Name": "Malvik", "WarningList": [] },
      { "Id": "5041", "Name": "Snåsa", "WarningList": [] },
      { "Id": "5047", "Name": "Overhalla", "WarningList": [] },
      { "Id": "5061", "Name": "Rindal", "WarningList": [] },
      { "Id": "5033", "Name": "Tydal", "WarningList": [] },
      { "Id": "5027", "Name": "Midtre Gauldal", "WarningList": [] },
      { "Id": "5025", "Name": "Røros", "WarningList": [] },
      { "Id": "5029", "Name": "Skaun", "WarningList": [] },
      { "Id": "5035", "Name": "Stjørdal", "WarningList": [] },
      { "Id": "5007", "Name": "Namsos", "WarningList": [] },
      { "Id": "5055", "Name": "Heim", "WarningList": [] },
      { "Id": "5020", "Name": "Osen", "WarningList": [] },
      { "Id": "5036", "Name": "Frosta", "WarningList": [] },
      { "Id": "5049", "Name": "Flatanger", "WarningList": [] },
      { "Id": "5028", "Name": "Melhus", "WarningList": [] },
      { "Id": "5046", "Name": "Høylandet", "WarningList": [] },
      { "Id": "5054", "Name": "Indre Fosen", "WarningList": [] },
      { "Id": "5060", "Name": "Nærøysund", "WarningList": [] },
      { "Id": "5045", "Name": "Grong", "WarningList": [] },
      { "Id": "5042", "Name": "Lierne", "WarningList": [] },
      { "Id": "5056", "Name": "Hitra", "WarningList": [] },
      { "Id": "5053", "Name": "Inderøy", "WarningList": [] },
      { "Id": "5006", "Name": "Steinkjer", "WarningList": [] },
      { "Id": "5026", "Name": "Holtålen", "WarningList": [] },
      { "Id": "5052", "Name": "Leka", "WarningList": [] },
      { "Id": "5022", "Name": "Rennebu", "WarningList": [] },
      { "Id": "5034", "Name": "Meråker", "WarningList": [] },
      { "Id": "5038", "Name": "Verdal", "WarningList": [] },
      { "Id": "5043", "Name": "Røyrvik", "WarningList": [] },
      { "Id": "5057", "Name": "Ørland", "WarningList": [] },
      { "Id": "5021", "Name": "Oppdal", "WarningList": [] },
      { "Id": "5032", "Name": "Selbu", "WarningList": [] },
      { "Id": "5059", "Name": "Orkland", "WarningList": [] },
      { "Id": "5037", "Name": "Levanger", "WarningList": [] },
      { "Id": "5058", "Name": "Åfjord", "WarningList": [] },
      { "Id": "5001", "Name": "Trondheim", "WarningList": [] },
      { "Id": "5014", "Name": "Frøya", "WarningList": [] },
      { "Id": "5044", "Name": "Namsskogan", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "40",
    "Name": "Telemark",
    "MunicipalityList": [
      { "Id": "4034", "Name": "Tokke", "WarningList": [] },
      { "Id": "4020", "Name": "Midt-Telemark", "WarningList": [] },
      { "Id": "4005", "Name": "Notodden", "WarningList": [] },
      { "Id": "4016", "Name": "Drangedal", "WarningList": [] },
      { "Id": "4018", "Name": "Nome", "WarningList": [] },
      { "Id": "4036", "Name": "Vinje", "WarningList": [] },
      { "Id": "4003", "Name": "Skien", "WarningList": [] },
      { "Id": "4026", "Name": "Tinn", "WarningList": [] },
      { "Id": "4010", "Name": "Siljan", "WarningList": [] },
      { "Id": "4012", "Name": "Bamble", "WarningList": [] },
      { "Id": "4032", "Name": "Fyresdal", "WarningList": [] },
      { "Id": "4001", "Name": "Porsgrunn", "WarningList": [] },
      { "Id": "4024", "Name": "Hjartdal", "WarningList": [] },
      { "Id": "4014", "Name": "Kragerø", "WarningList": [] },
      { "Id": "4028", "Name": "Kviteseid", "WarningList": [] },
      { "Id": "4022", "Name": "Seljord", "WarningList": [] },
      { "Id": "4030", "Name": "Nissedal", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "56",
    "Name": "Finnmark",
    "MunicipalityList": [
      { "Id": "5624", "Name": "Lebesby", "WarningList": [] },
      { "Id": "5634", "Name": "Vardø", "WarningList": [] },
      { "Id": "5630", "Name": "Berlevåg", "WarningList": [] },
      { "Id": "5614", "Name": "Loppa", "WarningList": [] },
      { "Id": "5612", "Name": "Kautokeino", "WarningList": [] },
      { "Id": "5628", "Name": "Tana", "WarningList": [] },
      { "Id": "5605", "Name": "Sør-Varanger", "WarningList": [] },
      { "Id": "5607", "Name": "Vadsø", "WarningList": [] },
      { "Id": "5618", "Name": "Måsøy", "WarningList": [] },
      { "Id": "5632", "Name": "Båtsfjord", "WarningList": [] },
      { "Id": "5636", "Name": "Nesseby", "WarningList": [] },
      { "Id": "5601", "Name": "Alta", "WarningList": [] },
      { "Id": "5620", "Name": "Nordkapp", "WarningList": [] },
      { "Id": "5616", "Name": "Hasvik", "WarningList": [] },
      { "Id": "5610", "Name": "Karasjok", "WarningList": [] },
      { "Id": "5626", "Name": "Gamvik", "WarningList": [] },
      { "Id": "5603", "Name": "Hammerfest", "WarningList": [] },
      { "Id": "5622", "Name": "Porsanger", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "31",
    "Name": "Østfold",
    "MunicipalityList": [
      { "Id": "3103", "Name": "Moss", "WarningList": [] },
      { "Id": "3101", "Name": "Halden", "WarningList": [] },
      { "Id": "3110", "Name": "Hvaler", "WarningList": [] },
      { "Id": "3120", "Name": "Rakkestad", "WarningList": [] },
      { "Id": "3114", "Name": "Våler", "WarningList": [] },
      { "Id": "3124", "Name": "Aremark", "WarningList": [] },
      { "Id": "3118", "Name": "Indre Østfold", "WarningList": [] },
      { "Id": "3105", "Name": "Sarpsborg", "WarningList": [] },
      { "Id": "3116", "Name": "Skiptvet", "WarningList": [] },
      { "Id": "3112", "Name": "Råde", "WarningList": [] },
      { "Id": "3122", "Name": "Marker", "WarningList": [] },
      { "Id": "3107", "Name": "Fredrikstad", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  },
  {
    "Id": "03",
    "Name": "Oslo",
    "MunicipalityList": [{ "Id": "0301", "Name": "Oslo", "WarningList": [] }],
    "HighestActivityLevel": null
  },
  {
    "Id": "39",
    "Name": "Vestfold",
    "MunicipalityList": [
      { "Id": "3903", "Name": "Holmestrand", "WarningList": [] },
      { "Id": "3901", "Name": "Horten", "WarningList": [] },
      { "Id": "3909", "Name": "Larvik", "WarningList": [] },
      { "Id": "3911", "Name": "Færder", "WarningList": [] },
      { "Id": "3905", "Name": "Tønsberg", "WarningList": [] },
      { "Id": "3907", "Name": "Sandefjord", "WarningList": [] }
    ],
    "HighestActivityLevel": null
  }
]
